import {FilterCategory, FilterCategoryType, FilterSets} from "@/components/filterDropdown/FilterDropdown.ts";
import {FilterDropdown} from "@/components/filterDropdown/FilterDropdown.tsx";
import {StatusPageList, StatusPageStatus, StatusPageType, StatusPageTypeDisplayName} from "@/lib/types/statuspages.ts";

type StatusPagesFiltersProps = {
  filterSets: FilterSets<FilterCategory>;
  onFilterSetChange: (filterSet: FilterSets<FilterCategory>) => void;
  items: StatusPageList[];
};

export function StatusPagesFilters({filterSets, onFilterSetChange, items}: StatusPagesFiltersProps) {
  const spIds = items.map((sp) => ({
    key: sp.id.toString(),
    display: sp.name,
  }));

  const filterFields: FilterCategory[] = [
    {
      type: FilterCategoryType.ARRAY,
      key: "status",
      display: "Status",
      options: [
        {
          key: StatusPageStatus.OPERATIONAL,
          display: "Operational",
        },
        {
          key: StatusPageStatus.ACTIVE_MAINTENANCE,
          display: "Active Maintenance",
        },
        {
          key: StatusPageStatus.SCHEDULED_MAINTENANCE,
          display: "Scheduled Maintenance",
        },
        {
          key: StatusPageStatus.ACTIVE_INCIDENTS,
          display: "Active Incidents",
        },
      ],
    },
    {
      type: FilterCategoryType.ARRAY,
      key: "page_type",
      display: "Type",
      options: [
        {
          key: StatusPageType.PUBLIC,
          display: `${StatusPageTypeDisplayName[StatusPageType.PUBLIC]} Page`,
        },
        {
          key: StatusPageType.PUBLIC_SLA,
          display: `${StatusPageTypeDisplayName[StatusPageType.PUBLIC_SLA]} Page`,
        },
        {
          key: StatusPageType.INTERNAL,
          display: `${StatusPageTypeDisplayName[StatusPageType.INTERNAL]} Page`,
        },
      ],
    },
    {
      type: FilterCategoryType.ARRAY,
      key: "ids",
      display: "Status Page",
      options: spIds,
    },
  ];

  return (
    <FilterDropdown
      categories={filterFields}
      appliedFilterSets={filterSets}
      onApply={onFilterSetChange}
      loading={false}
    />
  );
}
